<template>
    <IRadioGroup v-bind="props.radioOptions" :radios="radios" :class="{ 'r-group-v-wrapper': props.vertical }" @change="changeHandler" />
</template>

<script>
import IRadioGroup from "@/views/zhiji/bComponents/checks/RadioGroup.vue";

export default {
    name: "RadioGroup",
    components: {
        IRadioGroup
    },
    props: ["value", "widget", "verifyInfo", "rules"],
    computed: {
        props() {
            return this.widget.props;
        },
        radios() {
            const self = this;
            const ret = this.props.radios.map(radio => {
                const newRadio = {
                    ...radio,
                    checked: self.value === radio.value
                };
                if (newRadio.extend && self.value) {
                    newRadio.checked = self.value.value === radio.value;
                    if (self.value.extend) {
                        newRadio.extend.value = self.value.extend.value;
                    }
                }
                return newRadio;
            });
            return ret;
        }
    },
    methods: {
        changeHandler(newValue) {
            this.$emit("change", newValue);
            this.verifyHandler(newValue);
        },
        verifyHandler(radio) {
            if (!this.rules.some(rule => rule.required)) {
                return;
            }

            const verifyInfo =
                !radio.extend || (radio.extend && radio.extend.value)
                    ? { isValid: true, message: "" }
                    : { isValid: false, message: "请输入必要内容" };
            this.$emit("verify", verifyInfo);
        }
    }
};
</script>

<style scoped lang="less">
.r-group-v-wrapper {
    display: flex;
    flex-direction: column;

    /deep/ .group-radio {
        height: 32px;
        margin-bottom: 5px;
    }
}
</style>
